export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "deliveryNote": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delivery notes"])},
        "upcoming": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upcoming"])},
        "delivered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delivered"])}
      }
    }
  })
}
